// 自动聚焦指令
export default {
  inserted: function(el){
    el.querySelector('input').focus();
  }
}
